import "./modules/commerce/addresses";
import * as Shop from "./modules/shop";

// Shop Product
if (document.querySelector(".js-product-list")) {
    Shop.productList();
}

if (document.querySelector(".js-product")) {
    Shop.product();
}

// Shop Payment
if (document.getElementById("payment-form")) {
    Shop.checkout();
}
